import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/IconList/sgds-icon-list";
import { register } from "../../utils/ce-registry";

register("sgds-icon-list", Component);

export default createComponent({
  react: React,
  tagName: "sgds-icon-list",
  elementClass: Component,
  events: {}
});
